// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ctki","col":"styles_col__1tHX4"};